<template>
  <section>
    <div class="form-content">

      <div class="tip" style="margin:0 0 0 20px">* 选择车辆</div>
      <el-form-item label="选择车辆">
        <el-select @change="forceUpdate" size="small" class="project-list-select" v-model="form.carId" filterable
          placeholder="请选择(可搜索车牌号)">
          <el-option v-for="item in carList" :key="item.id" :label="item.xh+' - '+item.plateNo+' - '+item.type"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="clear" v-if="selectCar">
        <!-- <el-col :span="8"> -->
        <el-form-item label="使用人">
          <user-info :userData='selectCar.user'></user-info>
        </el-form-item>
        <!-- </el-col> -->
      </div>


      <div class="tip" style="margin:0 0 0 20px">* 里程抄见数(0.10元/公里)</div>
      <div class="clear">
        <el-col :span="8">
          <el-form-item label="上期数">
            <el-input size="small" v-model="form.sqs"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="本期数">
            <el-input size="small" v-model="form.bqs"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="补贴金额">
            <el-input size="small" v-model="form.btje"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <div class="tip" style="margin:0 0 0 20px">* 奖励信息</div>
      <div class="clear">
        <el-form-item label="奖励事项">
          <el-input type="textarea" placeholder="奖励事项" :autosize="{ minRows: 2, maxRows: 4}" size="small"
            v-model="form.jlsx"></el-input>
        </el-form-item>
      </div>
      <div class="clear">
        <el-col :span="8">
          <el-form-item label="奖励金额">
            <el-input size="small" v-model="form.jlje"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="tip" style="margin:0 0 0 20px">* 处罚信息</div>
      <div class="clear">
        <el-form-item label="处罚事项">
          <el-input type="textarea" placeholder="处罚事项" :autosize="{ minRows: 2, maxRows: 4}" size="small"
            v-model="form.cfsx"></el-input>
        </el-form-item>
      </div>
      <div class="clear">
        <el-col :span="8">
          <el-form-item label="处罚金额">
            <el-input size="small" v-model="form.cfje"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <div class="tip" style="margin:0 0 0 20px">* 核发金额信息</div>
      <div class="clear">
        <el-col :span="8">
          <el-form-item label="核发金额总计">
            <el-input size="small" type="number" v-model="form.total"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item label="大写金额：">
            {{ form.totalDx }}
          </el-form-item>
        </el-col>
      </div>

    </div>
  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['formByFather', 'userData', 'useApplyType', 'carType'],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      }),
    },
    components: {
      UserInfo,
    },
    data() {
      return {
        selectCar: '',
        form: {},
        carList: [],
        depId: "",
      }
    },
    created() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      this.getCarLists()
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
        this.carList.map(item => {
          if (item.id == this.form.carId) {
            this.selectCar = item
          }
        });
      },
      // 获取所有车辆
      getCarLists() {
        ajax.get('/car/list', {
          depId: this.depId
        }, (res) => {
          this.loading = false
          this.carList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      },
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
      "form.total"() {
        if (this.form.total) {
          this.form.totalDx = util.convertCurrency(this.form.total)
        }
      },
      "form.carId"() {
        this.carList.map(item => {
          if (item.id == this.form.carId) {
            this.selectCar = item
          }
        });
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/car/rewards.vue